"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

require("./QtyControls.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var QtyControls = function QtyControls(props) {
  var id = props.id,
      onAdd = props.onAdd,
      onRemove = props.onRemove,
      qty = props.qty,
      max = props.max,
      mini = props.mini,
      isMobile = props.isMobile,
      soldOut = props.soldOut;
  var isMaxed = qty === max;
  var minusIconStyles = (0, _classnames2.default)({
    "ion-close-circled": qty === 1,
    "ion-minus-circled": qty > 1
  });
  var plusIconStyles = (0, _classnames2.default)({
    "ion-plus-circled": true,
    "c-light-grey": isMaxed || soldOut,
    "c-brand": !isMaxed && !soldOut
  });
  var iconfontSize = (0, _classnames2.default)({
    "fs-16": mini,
    "fs-30": !mini
  });
  var qtyfontSize = (0, _classnames2.default)({
    "fs-12": mini,
    "fs-14": isMobile,
    "fw-bold": isMobile
  });
  var bgColor = (0, _classnames2.default)({
    "bcg-light-grey": !mini
  });

  var toggleBtnAnimation = function toggleBtnAnimation(id) {
    var btn = document.querySelector("#" + id);

    if (btn) {
      requestAnimationFrame(function () {
        btn.classList.add("clicked");
        setTimeout(function () {
          btn.classList.remove("clicked");
        }, 500);
      });
    }
  };

  return _react2.default.createElement("div", {
    className: "qty-controls " + bgColor
  }, _react2.default.createElement("div", {
    className: "btn-wrapper d-flex flex-jsb flex-aic mar-a"
  }, _react2.default.createElement("button", {
    className: "icon-button naked-button cur-pointer c-light-grey " + iconfontSize,
    id: "remove-btn-" + id,
    onClick: function onClick() {
      onRemove();
      toggleBtnAnimation("remove-btn-" + id);
    }
  }, _react2.default.createElement("i", {
    className: minusIconStyles
  })), _react2.default.createElement("div", {
    className: qtyfontSize + " fw-normal w-90 mar-w-4 number-box d-flex flex-aic flex-jsa"
  }, qty, " ", qty === max && "MAX"), _react2.default.createElement("button", {
    className: "icon-button naked-button cur-pointer " + iconfontSize,
    id: "add-btn-" + id,
    onClick: function onClick() {
      onAdd();
      toggleBtnAnimation("add-btn-" + id);
    },
    disabled: qty === max || soldOut
  }, _react2.default.createElement("i", {
    className: plusIconStyles
  }))));
};

exports.default = QtyControls;